// Function to fetch folder content
export const fetchFolderContent = async ({ accessToken, selectedProjectId, accFolderId }) => {
    // if (!accessToken || !selectedProjectId || !accFolderId) {
    //     throw new Error(
    //         `Missing required parameters for fetching folder content: accessToken=${accessToken}, selectedProjectId=${selectedProjectId}, accFolderId=${accFolderId}`
    //     );
    // }


    const requestHeaders = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
    });

    const request = new Request(
        `https://developer.api.autodesk.com/data/v1/projects/${selectedProjectId}/folders/${accFolderId}/contents`,
        {
            method: 'GET',
            headers: requestHeaders,
        }
    );

    try {
        const response = await fetch(request);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status} ${response.statusText}`);
        }

        const folderContent = await response.json();
        console.log('Fetched folder content:', folderContent);
        return folderContent;
    } catch (error) {
        console.error('Error fetching folders content:', error);
        throw error;
    }
};